
////////////////////////////////////
// M069 product compare

function initProductcompare(){
    
	if($(".productcompare").length > 0){
		//console.log("initProductcompare()");
	}
}

function updateProductcompare(){
    
	if($(".productcompare").length > 0){
		
		$(".productcompare").each(function(){

			var h = 0;
			var $mainHeader = $(this).find(".productcompare__header--main");
			
			if($mainHeader && $mainHeader.length > 0){
				if($(window).width() < _breakpointMedium){
					var $mainHeaderHeadline1 = $mainHeader.find(".productcompare__table-headline").first();
					//mobile calculation
					if($mainHeaderHeadline1 && $mainHeaderHeadline1.length > 0){
						h = $mainHeader.outerHeight() + $mainHeaderHeadline1.outerHeight();
					}
				}
				else{
					//desktop calculation
					h = $mainHeader.outerHeight();
				}
			}
			
			//console.log("updateProductcompare() // h:" + h);
			
			var $additionalHeader = $(this).find(".productcompare__header--additional");
			if($additionalHeader && $additionalHeader.length > 0){
				$additionalHeader.css("top", h + "px");

				$additionalHeader.off().on("click", function(){
					//console.log("additional header click");
					$(this).toggleClass("opened");
					
					var $tables = $(this).parent(".productcompare__tables");
					$tables.find(".productcompare__body--additional").toggleClass("opened");
				});
				$additionalHeader.on("keydown", handleKeyDownForClick);
			}
		});
		
	}
}
